module.exports = __webpack_public_path__ + "media/src/assets/Images/MessagePreview-7cbbfb96e8b1897e9c72eeb8cf256ac8.svg";